import { render, staticRenderFns } from "./AgreementsInfo.vue?vue&type=template&id=07b4a5fe&"
import script from "./AgreementsInfo.vue?vue&type=script&lang=js&"
export * from "./AgreementsInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports